import React ,{useState, useEffect} from 'react';
import ButtonSection from '../components/button-section';
import InfoBulle from  '../components/info-bulle';
import RadioBox from '../components/radio-box';
import When from '../components/when';
import logo from "../img/logo-bleu.webp";

export default function Conjoint (props) {
	const [dataValid, setDataValid] =  useState(false);
	const [errors  , setErrors] = useState([]);
	const [couple , setCouple] = useState();
	const [ageConjoint , setAgeConjoint] = useState();
	const {step   , restart , simulationData} = props;

	useEffect( ()=> {
		setDataValid(isDataValid());
	} , [couple,ageConjoint]);

	const goToNextStep = ()=>{
		if (dataValid){
			props.updateData( 'demandeur' , {enCouple : couple});
			props.updateData( 'conjoint' , { age : ageConjoint});
			props.nextStep()

		} else {
			setErrors(getInputErrors());
		}
	};

	const getInputErrors = ()=> {
		let errors = [];
		if (typeof couple === 'undefined') {
			errors.push( "Veuillez renseigner votre situation" );
		}
		if ( couple && isNaN(ageConjoint)){
			errors.push( "Veuillez renseigner l'âge de votre conjoint");
		}
		return errors;
	}

	const isDataValid = ()=> { 
		if (typeof couple !== 'undefined'){
			return (!couple || (couple && !isNaN(ageConjoint)) );
		}
		return false;
	};

	const changeCouple = (newValue)=>{
		setDataValid(true);
		setCouple(JSON.parse(newValue));
	}

	const updateAgeConjoint = (e)=>{
		const newAge = parseInt ( e.target.value);
		setAgeConjoint(newAge);
	}

	const infoCouple = <p>Indiquez en couple si vous êtes mariés, pacsés ou en union libre.</p>;///

	return <div id="conjoint" className="sim-form min-height" >

		<div className="container">
			<div className="question-set" id="question-couple">
				<div className="question">
					<label>Vivez-vous en couple ou vivez-vous seul ? <InfoBulle message={infoCouple} /></label>
				</div>
				<div className="input">
					<RadioBox
						model={{couple}}
						handler={changeCouple}
						options= {{
							"En couple" :  true,
							"Seul" : false
						}}
					/>
				</div>
			</div>
			<When condition= {couple}>
				<div className="question-set">
					<div className="question">
						<label> Age de votre conjoint</label>
					</div>
					<div className="input">
						<input type="number"
							className="form-control"
							onChange={updateAgeConjoint}
							placeholder="Ex: 25"
						/>
						<span className="unit">ans</span>
					</div>

				</div>
			</When>
		</div>
		<ButtonSection
			restart={restart}
			action={goToNextStep}
			dataValid= {dataValid}
			errors={errors}
			data={simulationData}
			step={step}
		></ButtonSection>
	<div className="site-address pt-3 pt-sm-0">
      <div className="col">
        <img src={logo} alt="logo aide-sociale.fr"/>
      </div>
    </div>
	</div>
}